import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Register from "../components/register";
import QueryItems from "../components/query_general";
import AuthLogin from "../components/auth/auth_login";
import Validacao from "../components/validation";
import DashBoard from "../components/dashboard";
import QueryTransactions from "../components/query_per_transaction";
import Auth from "./auth";

const PrivateRouteDefault = ({ component: Component, isAuth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

const PrivateRoutePrivileged = ({ component: Component, isAuth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.isPrivilegedUser() ? (
        <Component {...props} />
      ) : Auth.isAuthenticated() ? (
        <Redirect
          to={{ pathname: "/painel", state: { from: props.location } }}
        />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/login" component={AuthLogin} />
      <PrivateRouteDefault exact path="/painel" component={DashBoard} />
      <PrivateRoutePrivileged exact path="/cadastro" component={Register} />
      <PrivateRoutePrivileged
        exact
        path="/consulta_malotes"
        component={QueryTransactions}
      />
      <PrivateRoutePrivileged
        exact
        path="/consulta_itens"
        component={QueryItems}
      />
      <PrivateRouteDefault exact path="/validacao" component={Validacao} />
      <PrivateRouteDefault
        exact
        path="/logout"
        component={() => (
          <Route
            render={props => (
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            )}
          />
        )}
      />
      <Route
        path="*"
        component={() => (
          <Route
            render={props =>
              Auth.isAuthenticated() ? (
                <Redirect
                  to={{
                    pathname: "/painel",
                    state: { from: props.location }
                  }}
                />
              ) : (
                <Redirect
                  to={{ pathname: "/login", state: { from: props.location } }}
                />
              )
            }
          />
        )}
      />
    </Switch>
  </BrowserRouter>
);
export default Routes;
